export const color = {
    primary: {
        gradient: 'linear-gradient(78.21deg, #fadf4a 0.00%, #f9463a 30.73%, #08b7ea 67.19%, #03dec8 94.57%)',
        action: {1: '#edf6ff', 2: '#c7e4ff', 3: '#8bc7ff', 4: '#399ffe', 6: '#1372ec', 8: '#1a50ad', 9: '#062d70'},
        gray: {
            0: '#fcfcfc',
            1: '#f9f9f9',
            2: '#f3f3f3',
            3: '#e5e8e8',
            4: '#d6dcdd',
            5: '#b7bcc0',
            6: '#6c727b',
            7: '#565b66',
            8: '#353a3f',
            9: '#282829',
        },
        navy: {
            0: '#f5f6ff',
            1: '#d6d7fd',
            2: '#aeb0f1',
            3: '#8787db',
            4: '#6b6bbd',
            5: '#525296',
            6: '#3f3f71',
            7: '#333357',
            8: '#262646',
            9: '#181d3a',
        },
        pureWhite: '#ffffff',
    },
    secondary: {
        lime: {0: '#f2fff9', 6: '#12a344', 9: '#004a20'},
        indigo: {
            0: '#f2f3ff',
            1: '#ced4f4',
            2: '#9dabf2',
            3: '#687cdf',
            4: '#4a61d4',
            5: '#2e45ba',
            6: '#24389e',
            7: '#192b8a',
            8: '#101f6b',
            9: '#071140',
        },
        green: {
            0: '#dcf3ef',
            1: '#b2e3db',
            2: '#79d1c3',
            3: '#34ad95',
            4: '#1a8973',
            5: '#00634f',
            6: '#045242',
            7: '#043f33',
            8: '#023128',
            9: '#01211b',
        },
        purple: {
            0: '#f2ebf3',
            1: '#dabfe9',
            2: '#bb80dc',
            3: '#9a52c1',
            4: '#752e9c',
            5: '#5d237d',
            6: '#451c5c',
            7: '#390c53',
            8: '#2b073f',
            9: '#180323',
        },
    },
    accent: {
        teal: {
            0: '#edfffc',
            1: '#c2fef5',
            2: '#50fae3',
            3: '#1cebcf',
            4: '#16dcc1',
            5: '#12c7ae',
            6: '#0ba893',
            7: '#078675',
            8: '#055f53',
            9: '#033932',
        },
        blue: {
            0: '#e7f7ff',
            1: '#c3ecff',
            2: '#86d8ff',
            3: '#46c4ff',
            4: '#00adff',
            5: '#029de7',
            6: '#0387c6',
            7: '#0173a9',
            8: '#004c71',
            9: '#003148',
        },
        yellow: {
            0: '#fffdea',
            1: '#fff7ba',
            2: '#ffef70',
            3: '#ffe300',
            4: '#f5d029',
            5: '#eac10b',
            6: '#e2b104',
            7: '#bd9403',
            8: '#8f7000',
            9: '#493b08',
        },
        red: {
            0: '#fff8f8',
            1: '#ffd7d3',
            2: '#f3b4ae',
            3: '#ee8279',
            4: '#f05245',
            5: '#e03729',
            6: '#cd2113',
            7: '#a11409',
            8: '#80130a',
            9: '#600a03',
        },
    },
};
